import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import TelegramIcon from '@mui/icons-material/Telegram';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { PLAYER_KANBAN_STATUS_LABELS, PLAYER_KANBAN_STATUS_COLORS } from '../../../types';
import { defaultAvatar } from '../../../types';
export const KanbanPlayerCard = ({ kanbanPlayer, onClick }) => {
    var _a;
    const { player } = kanbanPlayer;
    const effectiveStatus = (_a = kanbanPlayer.overriddenStatus) !== null && _a !== void 0 ? _a : kanbanPlayer.computedStatus;
    const statusColor = PLAYER_KANBAN_STATUS_COLORS[effectiveStatus];
    const statusLabel = PLAYER_KANBAN_STATUS_LABELS[effectiveStatus];
    return (_jsxs(Box, Object.assign({ onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(kanbanPlayer), sx: {
            backgroundColor: '#1F1F1F',
            border: '1px solid #2D2D2D',
            borderLeft: `3px solid ${statusColor}`,
            borderRadius: '8px',
            padding: '12px',
            cursor: onClick ? 'pointer' : 'default',
            transition: 'background-color 0.15s',
            '&:hover': onClick
                ? { backgroundColor: '#2D2D2D' }
                : undefined,
        } }, { children: [_jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' } }, { children: [_jsx(Avatar, { src: player.photoUrl || defaultAvatar, alt: player.realName, sx: { width: 36, height: 36, flexShrink: 0 } }), _jsxs(Box, Object.assign({ sx: { minWidth: 0 } }, { children: [_jsx(Typography, Object.assign({ variant: "body2", sx: {
                                    fontWeight: 600,
                                    color: '#F5F5F5',
                                    fontSize: '13px',
                                    lineHeight: '18px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                } }, { children: player.realName })), player.gameName && player.gameName !== player.realName && (_jsx(Typography, Object.assign({ variant: "caption", sx: {
                                    color: '#A3A3A3',
                                    fontSize: '11px',
                                    lineHeight: '14px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    display: 'block',
                                } }, { children: player.gameName })))] }))] })), player.telegram && (_jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' } }, { children: [_jsx(TelegramIcon, { sx: { fontSize: 14, color: '#2AABEE', flexShrink: 0 } }), _jsx(Typography, Object.assign({ variant: "caption", sx: {
                            color: '#2AABEE',
                            fontSize: '12px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        } }, { children: player.telegram.startsWith('@') ? player.telegram : `@${player.telegram}` }))] }))), _jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '6px' } }, { children: [_jsx(SportsEsportsIcon, { sx: { fontSize: 14, color: '#737373', flexShrink: 0 } }), _jsxs(Typography, Object.assign({ variant: "caption", sx: { color: '#737373', fontSize: '11px' } }, { children: [player.gamesCount, " ", getGamesLabel(player.gamesCount)] }))] }))] })));
};
function getGamesLabel(count) {
    if (count % 10 === 1 && count % 100 !== 11)
        return 'игра';
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100))
        return 'игры';
    return 'игр';
}
